import { createAsyncThunk } from "@reduxjs/toolkit";
import { addLocationAPI, deleteLocationByIdAPI, editLocationAPI, fetchFoodItemsByLocationIdAPI, fetchLocationByIdAPI, fetchLocationByURLAPI, fetchLocationsAPI, fetchUnassignedLocationsAPI, toggleFoodMenuAPI } from "./locationAPI";

// Adding Location
export const addLocation = createAsyncThunk("location/addLocation", async (body, { rejectWithValue }) => {
    try {
        const response = await addLocationAPI(body)
        return response
    } catch (error) {
        return rejectWithValue( error )
    }
})

// Edit Location
export const editLocation = createAsyncThunk("location/editLocation", async (body, { rejectWithValue }) => {
    try {
        const response = await editLocationAPI(body)
        return response
    } catch (error) {
        return rejectWithValue( error )
    }
})

// Fetch all locations
export const fetchLocations = createAsyncThunk("location/fetchLocations", async (body, { rejectWithValue }) => {
    try {
        const response = await fetchLocationsAPI()
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})

// Fetch food items by location Id
export const fetchFoodItemsByLocationId = createAsyncThunk("location/fetchFoodItemsByLocationId", async (id , { rejectWithValue }) => {
    try {
        const response = await fetchFoodItemsByLocationIdAPI(id)
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})

// Fetch All Unassigned location 
export const fetchUnassignedLocations = createAsyncThunk("location/fethUnassignedLocations", async ( _, { rejectWithValue }) => {
    try {
        const response = await fetchUnassignedLocationsAPI()
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})

/// Fetching Location by Location id
export const fetchLocationById = createAsyncThunk(
    "location/fetchLocationDetails",
    async(id, { rejectWithValue}) => {
        try {
            const response = await fetchLocationByIdAPI(id)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

/// Fetching Menu by Location ID
export const fetchMenuByLocation = createAsyncThunk(
    "location/fetchMenuByLocation",
    async(id, { rejectWithValue}) => {
        try {
            const response = await fetchFoodItemsByLocationIdAPI(id)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
) 

export const fetchLocationDetails = createAsyncThunk(
    "location/fetchFullDetails",
    async (id, { rejectWithValue }) => {
        try {
            // Fetch both simultaneously using Promise.all
            const [details, menu] = await Promise.all([
                fetchLocationByIdAPI(id),
                fetchFoodItemsByLocationIdAPI(id)
            ]);
            return { details, menu };
        } catch (error) {
            return handleThunkError(error, rejectWithValue);
        }
    }
);

/// Handling Availibility of food items
export const toggleFoodMenu = createAsyncThunk(
    "location/toggleFoodMenu",
    async(body, { rejectWithValue}) => {
        try {
            const response = await toggleFoodMenuAPI(body)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
) 

/// Deleting Location using the location Id
export const deleteLocationByLocationId = createAsyncThunk(
    "location/deleteLocationByLocationId",
    async(id, { rejectWithValue}) => {
        try {
            const response = await deleteLocationByIdAPI(id)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
) 

export const fetchLocationByURL = createAsyncThunk(
    "location/fetchLocationByURL",
    async(data, { rejectWithValue}) => {
        try {
            const response = await fetchLocationByURLAPI(data)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
) 